export default "__VITE_ASSET__DyuAImlo__"